import React from 'react'
import { Card, Box, CardActions, Divider, Grid } from '@material-ui/core'
import Content from 'components/JarCard/Content'
import TopSection from 'components/JarCard/TopSection'
import TitheChip from 'components/JarCard/TitheChip'
import RoundupChip from 'components/JarCard/RoundupChip'
import PayoutChip from 'components/JarCard/PayoutChip'
import useEntity from 'hooks/useEntity'
import PropTypes from 'prop-types'
import useCurrentUserProp from 'hooks/useCurrentUserProp'

export default function JarCard({ id }) {
  const { tithingEnabled } = useEntity('campaigns', id)
  const isCommunityAdmin = useCurrentUserProp('isCommunityAdmin')

  return (
    <Card>
      <Box position='relative'>
        <TopSection id={id} />
      </Box>

      <Content id={id} />
      <Divider />
      <CardActions>
        <Grid container spacing={1}>
          {tithingEnabled && <Grid item><TitheChip jarId={id} /></Grid>}
          <Grid item><RoundupChip jarId={id} /></Grid>
          {isCommunityAdmin && <Grid item><PayoutChip jarId={id} /></Grid>}
        </Grid>
      </CardActions>
    </Card>
  )
}

JarCard.propTypes = {
  id: PropTypes.string.isRequired
}
